import React, { useState } from "react";
import { makeStyles } from "@mui/styles";

import Typography from "@mui/material/Typography";

import Button from "@mui/material/Button";

import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";

import Checkbox from "@mui/material/Checkbox";
import InfoIcon from "@mui/icons-material/Info";
import Tooltip from "@mui/material/Tooltip";
import FormControlLabel from "@mui/material/FormControlLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Switch from "@mui/material/Switch";

import { saveMenuGroupOption } from "store/actions/restaurantMenu";
import { useDispatch, useSelector } from "react-redux";
import Divider from "@mui/material/Divider";

// import AddMenuItemDialog from "./AddMenuItemDialog";

import LinkIcon from "@mui/icons-material/Link";
import { noWheelInputProps } from "util/utils";
import { validateMenuItemName } from "util/validation";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
}));

const NewGroupOptionLink = (props) => {
  const { group } = props;

  const dispatch = useDispatch();
  const saveOption = (values) => dispatch(saveMenuGroupOption(values));

  const categories = useSelector(
    (state) => state.restaurantMenu.menuCategories
  );

  const [name, setName] = useState("");
  const [price, setPrice] = useState("");
  const [isDefault, setIsDefault] = useState(false);
  const [hideForWeb, setHideForWeb] = useState(false);
  const [isPrintDisabled, setIsPrintDisabled] = useState(false);
  const [shortName, setShortName] = useState("");
  const [openAddMenuItem, setOpenAddMenuItem] = useState(false);
  const [menuItem, setMenuItem] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedItem, setSelectedItem] = useState("");
  

  const close = () => {
    props.setIsNewOptionLink(false);
  };

  const nameError = validateMenuItemName(name);

  const isSaveButtonDisabled = () => {
    return !name || !!nameError || !price || !menuItem;
  };

  const save = () => {
    // console.log('menuItem', menuItem)
    const option = {
      name,
      price: Number(price),
      shortName,
      groupId: group.id,
      menuId: group.menuId,
      default: isDefault,
      sort: 999,
      hideForWeb,
      isPrintDisabled,
      menuItemId: menuItem ? menuItem.id : null,
      menuItemName: menuItem ? menuItem.name : null,
      category: selectedCategory,
    };
    saveOption(option);
    close();
  };

  const handleSwitchChange = (event) => {
    const name = event.target.name;
    const value = event.target.checked;
    if (name === "hideForWeb") {
      setHideForWeb(value);
    }
  };

  const openAddMenuItemDialog = (e) => {
    setOpenAddMenuItem(true);
  };

  const handleClose = () => {
    setOpenAddMenuItem(false);
  };

  const findMenuItem = (selectedItem) => {
    const newItem = categories
    .find((cat) => cat.name === selectedCategory)
    .items.find((item) => item.id === selectedItem);
    return newItem;
};

  const addItemHandler = (id) => {
    setSelectedItem(id);
    const item = findMenuItem(id);
    if (!item) {
      return;
    }
   
    setMenuItem(item);
    if (item) {
      setPrice(Number(item.price));
      setName(item.name);
      if(item.shortName) {
        setShortName(item.shortName);
      }
    }
  };

  return (
    <Grid container direction="column">
      <Grid container direction="row">
        <div>
          {/* <AddMenuItemDialog
            open={openAddMenuItem}
            closeHandler={handleClose}
            menuId={group.menuId}
            addMenuItem={addItemHandler}
          /> */}

<Divider />
        Select a Category
        <br />
        <Select
          fullWidth
          value={selectedCategory}
          onChange={(e) => setSelectedCategory(e.target.value)}
          placeholder="Select Category"
        >
          {categories.map((cat) => (
            <MenuItem key={cat.name} value={cat.name}>
              {cat.name}
            </MenuItem>
          ))}
        </Select>

        Select an Item
        <br />
        <Select
          fullWidth
          value={selectedItem}
          onChange={(e) => addItemHandler(e.target.value)}
          placeholder="Select Item"
        >
          {selectedCategory &&
            categories
              .find((cat) => cat.name === selectedCategory)
              .items.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
        </Select>

          <Typography>Linked item: {menuItem ? menuItem.name : ""}</Typography>

          {/* <Button
            variant="outlined"
            color="primary"
            size="small"
            startIcon={<LinkIcon />}
            onClick={openAddMenuItemDialog}
          >
            Link a menu item
          </Button> */}
        </div>

        <TextField
          margin="normal"
          name="name"
          fullWidth
          id="name"
          label="Name"
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
          value={name}
          error={!!nameError}
          helperText={nameError}
          onChange={(e) => setName(e.target.value)}
        />

        <TextField
          size="small"
          label="Short Name"
          margin="dense"
          name="shortName"
          type="text"
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
          value={shortName}
          onChange={(e) => setShortName(e.target.value)}
        />

        <TextField
          margin="normal"
          name="price"
          size="small"
          id="price"
          label="Price"
          type="number"
          inputProps={noWheelInputProps}
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
          value={price}
          onChange={(e) => setPrice(e.target.value)}
        />
   

      <Grid container direction="row" alignItems="center">
      <FormControlLabel
            control={
              <Switch
                checked={hideForWeb}
                onChange={handleSwitchChange}
                name="hideForWeb"
                color="primary"
              />
            }
            label="Hide For Web"
          />
        </Grid>
        <Checkbox
          name="allow_quantity"
          color="primary"
          value={isDefault}
          onChange={(e) => setIsDefault(e.target.checked)}
          inputProps={{ "aria-label": "secondary checkbox" }}
        />
        <Typography>Pre-select</Typography>
        <Tooltip
          title="This item will be appear as pre-selected in the menu."
          arrow
        >
          <InfoIcon />
        </Tooltip>
        <Checkbox
          name="isPrintDisabled"
          color="primary"
          checked={isPrintDisabled}
          onChange={(e) => setIsPrintDisabled(e.target.checked)}
          inputProps={{ "aria-label": "is print disabled checkbox" }}
        />
        <Typography>Print Disabled</Typography>
        <Tooltip title="This option will not be printed on receipts or kitchen tickets." arrow>
          <InfoIcon />
        </Tooltip>
      </Grid>
      <Grid container direction="row" justify="space-between" spacing={1}>
        <Button variant="outlined" onClick={close}>
          Cancel
        </Button>
        <Button
          variant="outlined"
          disabled={isSaveButtonDisabled()}
          color="primary"
          onClick={save}
        >
          Save
        </Button>
      </Grid>
    </Grid>
  );
};

export default NewGroupOptionLink;
